/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Link } from '@express-labs/raven-ui';
import s from './EmptyStateModal.module.scss';
import routes from '../../../../../routes/routes';

function EmptyStateModal({ onClose }) {
  return (
    <Modal
      isOpen
      onModalClose={onClose}
      shouldCloseOnOverlayClick={false}
      className={s.emptyOfferModalContainer}
    >
      <div className={s.emptyStateTitle} aria-label="emptyStateTitle">no offers available today</div>
      <div className={s.subTextEmptyState}>
        See
        {' '}
        <Link
          as="a"
          theme="light"
          size="body"
          href={routes.availableOffers.couponsPage.path}
        >
          Coupons Page
        </Link>
        {' '}
        to access deals or
        {' '}
        <br />
        {' '}
        level up your points with an
        {' '}
        <Link
          as="a"
          theme="light"
          size="body"
          href={routes.availableOffers.insiderBonus.path}
        >
          Insider Bonus.
        </Link>
        {' '}
      </div>
    </Modal>
  );
}

EmptyStateModal.propTypes = {
  onClose: PropTypes.func,
};

export default EmptyStateModal;
